import {
  LayoutGrid,
  Beaker,
  Calendar,
  Users,
  BarChart3,
  Server,
  Bot,
  Building2,
  Coffee,
} from "lucide-react"
import { useTranslation } from "react-i18next"

import { NavFooter } from "@/components/nav-footer"
import { NavMain } from "@/components/nav-main"
import { NavUser } from "@/components/nav-user"
import { OrgSwitcher } from "@/components/org-switcher"
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
} from "@/components/ui/sidebar"
import { dashboardPath, cuppingsPath, samplesPath, coffeesPath } from "@/routes"
import type { NavItem } from "@/types"

export function AppSidebar() {
  const { t } = useTranslation()

  const mainNavItems: NavItem[] = [
    {
      title: t("sidebar.panel"),
      href: dashboardPath(),
      icon: LayoutGrid,
    },
    {
      title: t("sidebar.samples"),
      href: samplesPath(),
      icon: Beaker,
    },
    {
      title: t("sidebar.sessions"),
      href: cuppingsPath(),
      icon: Calendar,
    },
    {
      title: t("sidebar.my_coffees"),
      href: coffeesPath(),
      icon: Coffee,
    },
    {
      title: t("sidebar.cuppers"),
      href: "/cuppers",
      icon: Users,
    },
    {
      title: t("sidebar.organizations", "Organizations"),
      href: "/organizations",
      icon: Building2,
    },
    {
      title: t("sidebar.metrics"),
      href: "/metrics",
      icon: BarChart3,
    },
    {
      title: t("sidebar.assistant"),
      href: "/assistant",
      icon: Bot,
    },
  ]

  const footerNavItems: NavItem[] = [
    {
      title: t("sidebar.connect_mcp"),
      href: "/connect_mcp",
      icon: Server,
    },
  ]

  return (
    <Sidebar collapsible="icon" variant="inset">
      <SidebarHeader>
        <OrgSwitcher />
      </SidebarHeader>

      <SidebarContent>
        <NavMain items={mainNavItems} />
      </SidebarContent>

      <SidebarFooter>
        <NavFooter items={footerNavItems} className="mt-auto" />
        <NavUser />
      </SidebarFooter>
    </Sidebar>
  )
}
